export const MediaLibraryConfig = {
  MEDIA_LIBRARY_ITEMS_SELECT_COUNT: 30,
};
